import * as Yup from 'yup';

export const adjustmentReviewSchema = Yup.object().shape({
    premium: Yup.string().required('Required'),
    narrative: Yup.string().required('Required'),
    policyFee: Yup.string().required('Required'),
    professionalFee: Yup.string().required('Required'),
    slaFee: Yup.string().required('Required'),
    slaTax: Yup.string().required('Required'),
});
